import moment from 'moment';
import styled from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';
import { useAppDispatch } from '../../methods/redux/hooks';
import { getCurrentRemittanceMerchant } from '../../methods/redux/reducers/global-webhooks';

interface IBook {
	item: any;
}

const Style = styled.div`
	padding: 20px;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	cursor: pointer;

	& .label {
		font-size: 13px;
		color: #808080;
		font-style: italic;
	}

	& .green {
		font-size: 13px;
		color: green;
		font-style: italic;
		padding-left: 5px;
		text-transform: capitalize;
	}

	& .red {
		font-size: 13px;
		color: red;
		font-style: italic;
		padding-left: 5px;
		text-transform: capitalize;
	}

	& .business-name {
		display: flex;
		gap: 4px;

		& img {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
`;

const CompanyList = ({ item }: IBook) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const handleClick = (company: any) => {
		dispatch(getCurrentRemittanceMerchant(company));
		navigate(`./switch-wallet?merchantId=${company?.id}`);
	};

	return (
		<Link
			to={`./switch-wallet?merchantId=${item?.id}`}
			style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
		>
			<Style onClick={() => handleClick(item)}>
				<div>
					<div className="business-name">
						{item?.businessLogoURL && (
							<img src={item?.businessLogoURL} alt="business_name" />
						)}
						<p>
							<strong>{item?.businessName}</strong>
						</p>
					</div>
				</div>

				<div>
					<p>
						<strong>{item?.businessEmail}</strong>
					</p>
				</div>
				<div>
					<p className={item?.status === 'active' ? 'green' : 'red'}>
						{item?.status}
					</p>
				</div>
				<div>
					<p>
						{item?.createdAt
							? moment(item.createdAt).format('MMM DD, YY / hh:mm:ss a')
							: '--'}
					</p>
				</div>
			</Style>
		</Link>
	);
};

export default CompanyList;
